// src/pages/users/tabs/AddressTab.jsx
import React from 'react';

function FieldBox({ label, value }) {
  return (
    <div className="bg-gray-900 rounded-xl p-4">
      <div className="text-xs uppercase tracking-wide text-gray-400">{label}</div>
      <div className="mt-1 text-[15px] text-white break-words">{String(value || '—')}</div>
    </div>
  );
}

export default function AddressTab({ user }) {
  return (
    <div className="bg-[#1b2433] rounded-2xl shadow-lg p-6 space-y-4">
      <h3 className="text-white font-semibold">Address</h3>
      <div className="grid sm:grid-cols-2 gap-4">
        <FieldBox label="Address"      value={user.address} />
        <FieldBox label="City"         value={user.city} />
        <FieldBox label="State/Region" value={user.state} />
        <FieldBox label="Country"      value={user.country} />
        <FieldBox label="Postal Code"  value={user.postalCode} />
      </div>
    </div>
  );
}
